$ = require 'jquery'
Keyboard = require 'lib/keyboard'
Keys = require 'data/keys'
manageMembersTemplate = require 'views/templates/manage_members'
MemberAddView = require 'views/member/member-add-view'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
_ = require 'underscore'
mixin = require 'lib/mixin'
templates = require 'views/internal/templates'
l = require 'lib/localize'

module.exports = class BoardOrgMemberView extends View
  mixin MemberAddView, @

  viewTitleKey: 'organization members'

  initialize: ->
    org = @model.getOrganization()
    if org?
      @listenTo org.memberList, 'add remove reset', @frameDebounce @render
    return

  events:
    # org member stuff
    'click .js-board-members .js-select-member': 'didClickAddOrgMember'

    # etc
    'keyup': 'keyupEvent'
    'click .js-open-option': 'openOption'
    'mouseenter .js-select-member': 'hoverMember'

  renderOrgMembers: (idMems) ->
    members = []

    if idMems
      members = @modelCache.get('Member', idMems)
    else
      members = @model.orgMembersAvailable()

    memsEl = @$('.js-board-members .js-list').empty().show()

    for member in members
      data = member.toJSON()

      memsEl.append(
        templates.fill(
          'select_member',
          data,
          {},
          { member: templates.member }
        )
      )

    @$('.js-board-members .js-num-org-mem').empty().text(members.length)

    return

  render: ->
    data = @model.toJSON(prefs: true)
    data.orgName = @model.getOrganization()?.get('displayName')
    data.canInvite = true
    data.editable = @model.editable()

    @$el.html(manageMembersTemplate(data))

    @renderOrgMembers()

    @$('.js-board-members').removeClass('hide')

    @

  keyupEvent: (e) ->
    key = Keyboard.getKey(e)
    term = $('.js-search-input').val().trim()

    if key == Keys.Enter
      Util.stop(e)

      if @$('.js-org-members .js-list .selected').length > 0

        idMember = @$('.js-org-members .js-list .selected:first .js-select-member').attr('idMember')
        member = @modelCache.get('Member', idMember)

        @model.addMember(member)
        @$('.js-search-input').focus().select()

    # navigate menu list
    else if key in [Keys.ArrowUp, Keys.ArrowDown]
      Util.stop(e)
      Util.navMenuList($(PopOver.view?.el).find('.js-org-members .js-list'), '.item', key)

    else if term.length > 0
      @filterAndFillMembers(term)
      $('.js-org-members .js-list').removeClass('collapsed')
      $('.js-add-all-org-members').addClass('hide')

    else
      @renderOrgMembers()
      $('.js-org-members .js-list').addClass('collapsed')
      $('.js-add-all-org-members').removeClass('hide')

    return

  filterAndFillMembers: (term) ->
    idMems = _.pluck(@model.orgMembersAvailable(), 'id')
    mems = Util.filterMembers(@modelCache, term, idMems)

    mems = mems.slice(0, 7)

    if mems.length > 0
      @renderOrgMembers(mems)
      elem = @$('.js-org-members .js-list .item:first')
      Util.selectMenuItem(@$('.js-org-members .js-list'), '.item', elem)
    else
      @$('.js-org-members .js-list')
      .html('<li><p class="empty"></p></li>')
      .find('p').text l('no matched memebers')

    return

  didClickAddOrgMember: (e) ->
    Util.stop e
    idMember = $(e.target).closest('.js-select-member').attr('idMember')
    member = @modelCache.get 'Member', idMember
    @model.addMember(member)
    @render()



// WEBPACK FOOTER //
// ./app/scripts/views/board-menu/board-org-member-view.coffee